export default __webpack_public_path__ + "static/media/desktops.2b5e1040.jpg";